module.exports = __webpack_public_path__ + "img/logo_horizontal.258301fa.svg";